import { css } from "styled-components";
import { ThemeColor } from "../ThemeColors";
export const BorderSolidLightBlue = css `
  border: 3px solid ${ThemeColor.lightblue};
`;
